// extracted by mini-css-extract-plugin
module.exports = {"title":"TitleField_title__1Heqe","header":"TitleField_header__eICPH","description":"TitleField_description__1uk6t","descriptionTruncate":"TitleField_descriptionTruncate__2rRk3"};